import { Component, Input, Output, EventEmitter } from '@angular/core';
/**
 * Generated class for the ReactionComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'reaction',
  templateUrl: 'reaction.html',
})
export class ReactionComponent {

    @Input('activeReaction') activeReaction: string;

    @Output() onReaction: EventEmitter<string> = new EventEmitter<string>();

  reactions: any;

  constructor() {
    this.reactions = [
        {name: 'angry', active: false},
        {name: 'sad', active: false},
        {name: 'ok', active: false},
        {name: 'good', active: false},
        {name: 'happy', active: false}
    ];





  }

    ngOnInit() {
        for(let i = 0; i<this.reactions.length;i++) {
            if(this.reactions[i].name == this.activeReaction) {
                this.reactions[i].active = true;
            }
        }
        console.log('Reaction SET => '+this.activeReaction);
    }
  onReactionChoose(reaction: string) {
    for(let i = 0; i<this.reactions.length;i++) {
      if(this.reactions[i].name == reaction) {
          this.reactions[i].active = true;
          this.onReaction.emit(reaction);
      } else {
          this.reactions[i].active = false;
      }
    }
  }

  getReactionClass(reaction: string) {
    for(let i = 0; i<this.reactions.length;i++) {
        if(this.reactions[i].name == reaction) {
          if(this.reactions[i].active == true) {
              return this.reactions[i].name+' active';
          } else {
              return this.reactions[i].name;
          }

        }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/reaction/reaction.ts